@if (popupMode) {
  <mat-list>
    @for (item of localCodes; track item) {
      <mat-list-item (click)="selectLocal(item)" >{{item.lang}} </mat-list-item>
    }
  </mat-list>
}

@if (!popupMode) {
  @if (!setLargeMode) {
    @if (!iconButton) {
      <a (click)="onOpenDialog()" class="local-icon">
        <mat-icon matTooltip="{{'account.language' | transloco}}">translate</mat-icon>
      </a>
    }
    @if (iconButton) {
      <button mat-icon-button (click)="onOpenDialog()">
        <mat-icon matTooltip="{{'account.language' | transloco}}">translate</mat-icon>
      </button>
    }
  }
  @if (setLargeMode) {
    <div style="width: 100%; position: relative;">
      <button mat-button [matMenuTriggerFor]="profileMenu">
        <mat-icon>translate</mat-icon>
        <span style="margin-left: 5px">language</span>
      </button>
      <mat-menu #profileMenu>
        @for (item of localCodes; track item) {
          <button mat-menu-item (click)="selectLocal(item)">{{item.lang}}</button>
        }
      </mat-menu>
    </div>
  }
}

